export default {
  username: ['账户', 'Username'],
  usernameRequire: ['请输入管理账户', 'Please Enter Username'],
  usernameCorrectly: ['请输入正确的管理账户', 'Please enter correctly Username'],
  password: ['口令', 'Password'],
  passwordRequire: ['请输入您的口令', 'Please enter you password!'],
  passwordCorrectly: ['请输入格式正确的口令', 'Please enter correctly Password'],
  login: ['登录', 'Login'],
  loginRemember: ['记住帐户登录', 'Remember account login'],
  loginSuccess: ['登录成功，正在加载数据~', 'Successful login, data is being loaded~'],
  loginError: ['您的登录失败，请确实账户口令是否正确', 'Your login failed. Please confirm that the account password is correct'],
  loginManyTimes: ['您登录失败的次数过多，请稍后再试', 'You have failed to log in too many times, please try again later']
};
